<template>
  <div v-if="showTutorial" @click="closeTutorials" class="tutorial-person-type">
    <div class="wrap-cicle">
      <div id="has-circle" class="has-circle"></div>
      <div class="wrap-tutorial-text">
        <h3 class="tutorial-text">
          <img :src="FrameUp" alt="frame_down" class="frame-up" />
          <img :src="FrameLeft" alt="frame_left" class="frame-left" />
          คลิกเพื่อเลือก
          <img :src="FrameDown" alt="frame_down" class="frame-down" />
          <img :src="FrameRight" alt="frame_right" class="frame-right" />
        </h3>
      </div>
      <div id="has-circle-2" class="has-circle"></div>
    </div>
  </div>
</template>

<script>
import FrameUp from "@/assets/images/tutorials/frame-up.png";
import FrameDown from "@/assets/images/tutorials/frame-down.png";
import FrameLeft from "@/assets/images/tutorials/frame-left.png";
import FrameRight from "@/assets/images/tutorials/frame-right.png";
export default {
  name: "TutorialPersonType",
  props: {},
  data() {
    return {
      FrameDown,
      FrameUp,
      FrameLeft,
      FrameRight,
    };
  },

  computed: {
    showTutorial() {
      return this.$store.getters["app/getApp"].showPersonTypeTutorial;
    },
  },
  methods: {
    closeTutorials() {
      this.$store.dispatch("app/addValue", {
        name: "showPersonTypeTutorial",
        value: false,
      });
    },
  },
};
</script>

<style scoped>
.tutorial-person-type {
  width: 100%;
  height: 100%;
  top: 0px;
  position: absolute;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}
.wrap-cicle {
  width: 100%;
  height: 100%;
  position: relative;
}
.has-circle {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 100;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
}
#has-circle {
  height: 50%;
}
#has-circle-2 {
  top: 50%;
  bottom: 0;
}
.hide {
  display: none;
}
#has-circle:after,
#has-circle-2:after {
  margin: auto;
  content: " ";
  position: absolute;
  left: 0;
  right: 0;
  top: calc(25% + 56px);
  width: 100px;
  height: 100px;
  border-radius: 50%;
  z-index: 100;
  box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.85);
}
#has-circle-2:after {
  top: calc(50% - 222px);
}
.wrap-tutorial-text {
  position: absolute;
  top: calc(50% - 98px);
  font-weight: bold;
  z-index: 101;
  left: 0;
  color: #f2c94c;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tutorial-text {
  position: relative;
  width: 230px;
  height: 35px;
  text-align: center;
}
.frame-down,
.frame-up {
  position: absolute;
}
.frame-down {
  top: 35px;
  left: -32px;
}
.frame-up {
  bottom: 35px;
  right: 0;
}
.frame-left {
  display: none;
}
.frame-right {
  display: none;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .has-circle {
    width: 50%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: unset;
  }
  #has-circle {
    height: unset;
  }
  #has-circle-2 {
    left: 50%;
    bottom: 0;
    height: unset;
    top: 0;
  }
  .hide {
    display: none;
  }
  #has-circle:after,
  #has-circle-2:after {
    margin: auto;
    content: " ";
    position: absolute;
    left: 0;
    right: 0;
    top: calc(50% - 202px);
    width: 207px;
    height: 207px;
    border-radius: 50%;
    z-index: 100;
    box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.85);
  }
  #has-circle:after {
  }
  #has-circle-2:after {
  }
  .wrap-tutorial-text {
    position: absolute;
    top: 41%;
    font-weight: bold;
    z-index: 101;
    left: 0;
    color: #f2c94c;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .tutorial-text {
    position: relative;
    width: 159px;
    height: 42px;
    text-align: center;
  }
  .frame-left,
  .frame-right {
    position: absolute;
    display: block;
  }
  .frame-right {
    top: 35px;
    left: 150px;
  }
  .frame-left {
    bottom: 35px;
    right: 150px;
  }
  .frame-down {
    display: none;
  }
  .frame-up {
    display: none;
  }
}
</style>
